// extracted by css-extract-rspack-plugin
export default {"filters":"Fn9QooXjBJw7wLfX"};